// Which environment this console is — shown as a badge so nobody operates on production by mistake
// (task 355.3; rendered by the shell in 355.4).
//
// Source order: the build variable VITE_APP_ENV (set per deploy job), then the host name
// (console-dev.* / console-uat.* / localhost). An unrecognised host yields null — no badge rather than a
// wrong one.

export type ConsoleEnvironment = 'LOCAL' | 'DEV' | 'UAT' | 'PROD';

const KNOWN: readonly ConsoleEnvironment[] = ['LOCAL', 'DEV', 'UAT', 'PROD'];

export function resolveEnvironment(
  buildValue: string | undefined,
  hostname: string,
): ConsoleEnvironment | null {
  const fromBuild = buildValue?.trim().toUpperCase();
  if (fromBuild && (KNOWN as readonly string[]).includes(fromBuild)) {
    return fromBuild as ConsoleEnvironment;
  }

  const host = hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') return 'LOCAL';
  if (/(^|[.-])dev([.-]|$)/.test(host)) return 'DEV';
  if (/(^|[.-])uat([.-]|$)/.test(host)) return 'UAT';
  if (host === 'console.bancorix.com') return 'PROD';
  return null;
}

export function currentEnvironment(): ConsoleEnvironment | null {
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  return resolveEnvironment(import.meta.env.VITE_APP_ENV, hostname);
}
